import React from 'react';
import PropTypes from 'prop-types';
import InputConsumer from '../InputConsumer';
import { classes } from './Group.st.css';
var Group = function (_a) {
    var children = _a.children;
    return (React.createElement(InputConsumer, { consumerCompName: Group.displayName }, function () { return React.createElement("div", { className: classes.root }, children); }));
};
Group.displayName = 'Input.Group';
Group.propTypes = {
    children: PropTypes.node,
};
export default Group;
//# sourceMappingURL=Group.js.map